export const defaults = {
  timeout: 15_000,
};
